import { GET_ENTITLEMENTS_SUCCESS } from 'stash/actions/api/entitlements';
const entitlements = (state = {}, action) => {
	switch (action.type) {
		case GET_ENTITLEMENTS_SUCCESS: {
			return {
				...action.response,
			};
		}
		default:
			return state;
	}
};

export default entitlements;
